export default __webpack_public_path__ + "static/media/chinmaya- (4).84205b7d.png";